// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"f3077963","318":"d271a3d2","367":"45133a33","376":"0592af48","980":"d0a13d17"}[chunkId] + ".chunk.css";
};